/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.EftControlPanel {
    angular.module('meevo.plugins.eftControlPanel', []);
}